const ServiceProviderIdType = Symbol();

export class ServiceProviderId {
    [ServiceProviderIdType]: any;
    readonly value: string;

    private constructor(id: string) {
        this.value = id;
    }

    static fromString(id: string): ServiceProviderId {
        return new ServiceProviderId(id);
    }

    static fromNothing(): ServiceProviderId {
        return new ServiceProviderId("");
    }
}
